"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
const constants_1 = require("@powerednow/shared/constants");
let UserEntity = class UserEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], UserEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', primaryKey: true, requiresRole: { UPDATE: [constants_1.ROLES.PERMISSIONS.CAN_ADMIN_PN] }, fulltextSearchField: true,
    })
], UserEntity.prototype, "email", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string',
        hooks: { afterUpdate: [{ handler: 'onPasswordUpdated', args: [] }] },
    })
], UserEntity.prototype, "password", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', codeName: 'rememberMe' })
], UserEntity.prototype, "rememberme", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], UserEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', codeName: 'firstName', fulltextSearchField: true, indexWith: 'lastname',
    })
], UserEntity.prototype, "firstname", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'lastName', fulltextSearchField: true })
], UserEntity.prototype, "lastname", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], UserEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', serverOnly: true })
], UserEntity.prototype, "dt_expires", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', serverOnly: true })
], UserEntity.prototype, "logins", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: 0 })
], UserEntity.prototype, "last_login", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', serverOnly: true })
], UserEntity.prototype, "pwd_reminder_hash", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isDeleted', allowNull: false, defaultValue: false, serverOnly: true,
    })
], UserEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], UserEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UserEntity.prototype, "is_main", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: 1, allowNull: false })
], UserEntity.prototype, "is_active", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], UserEntity.prototype, "consumption_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'socialId' })
], UserEntity.prototype, "socialId", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'socialProvider' })
], UserEntity.prototype, "socialProvider", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', clientOnly: true })
], UserEntity.prototype, "token", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.5.0', type: 'int' })
], UserEntity.prototype, "signature_id", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.5.0', type: 'string', isJSON: true })
], UserEntity.prototype, "form_data", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '8.1.2' })
], UserEntity.prototype, "is_valid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UserEntity.prototype, "uuid", void 0);
UserEntity = __decorate([
    entity_1.EntityDecorator
], UserEntity);
exports.default = UserEntity;
//# sourceMappingURL=../../../../src/models/user/entity.js.map